module.exports = __webpack_public_path__ + "static/mia-88b0be648abd1e0628f7e077bac5dc75.png";